module.exports = __webpack_public_path__ + "img/drug-26.3ef4b089.png";